import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { StatsResponse } from '../../models/order/order-statistics.model';
import { OrderV2ApiResponse } from '../../../pages/orders/order-v2/order-v2.api.types';

export interface QueryOrderListFilterRequest {
  page?: number;
  pageSize?: number;
  salesChannelId?: number;
  affiliateId?: number;
  orderStatus?: string;
  incompleteOrders?: boolean;
  paymentNames?: string;
  callCenterOperatorName?: string;
  sellerName?: string;
  orderId?: string;
  q?: any
  incompletedOrders?:string
  invoicedOrders?:string
  waitingOrders?:string
}

export interface PageInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface Pageable<T> {
  items: T[];
  pageInfo: PageInfo;
}

export interface QueryOrderListItemModel {
  orderId?: string;
  status?: string;
  creationDate?: string;
  details?:any
}

export interface OrderDetailsModel {
  orderId?: string;
}

export interface VtexOrderLiteModel {
  orderId: string;
  creationDate: string;
  status: string;
  salesChannel: string;
  sellers: any;
  totals: any;
  paymentData: any;
  shippingData: any;
  selectedAddresses: any;
  ratesAndBenefitsData: any;
  clientProfileData: any;
  items: any;
}

@Injectable({ providedIn: 'root' })
export class OrdersService {
  private readonly baseUrl = `${environment.backend.url}/api/vtex/orders`;

  constructor(private readonly http: HttpClient) {}

  list(req: QueryOrderListFilterRequest): Observable<Pageable<QueryOrderListItemModel>> {
      let params = new HttpParams();

  if (req.page != null) {
    params = params.set('page', req.page.toString());
  }

  if (req.pageSize != null) {
    params = params.set('pageSize', req.pageSize.toString());
  }

  if(req.incompletedOrders != null){
    params = params.set("incompletedOrders",req.incompletedOrders.toString())
  }

  if(req.invoicedOrders != null){
    params = params.set("invoicedOrders",req.invoicedOrders.toString())
  }

  if(req.waitingOrders != null){
    params = params.set("waitingOrders",req.waitingOrders.toString())
  }

  if (req.q) {
    params = params.set('q', req.q);
    return this.http.get<Pageable<QueryOrderListItemModel>>(
      `${this.baseUrl}/v1/list`,
      { params }
    );
  }

  return this.http.get<Pageable<QueryOrderListItemModel>>(
    `${this.baseUrl}/v1/list`,
    { params }
  );
  }

  detail(orderId: string): Observable<OrderDetailsModel> {
    return this.http.get<OrderDetailsModel>(`${this.baseUrl}/v1/detail/${encodeURIComponent(orderId)}`);
  }

  detailV2(orderId: string): Observable<OrderV2ApiResponse> {
    return this.http.get<OrderV2ApiResponse>(
      `${this.baseUrl}/v1/detail-v2/${encodeURIComponent(orderId)}`
    );
  }

  vtex(orderId: string): Observable<VtexOrderLiteModel> {
    return this.http.get<VtexOrderLiteModel>(`${this.baseUrl}/v1/vtex/${encodeURIComponent(orderId)}`);
  }

  gan(orderId: string): Observable<VtexOrderLiteModel> {
    return this.http.get<VtexOrderLiteModel>(`${this.baseUrl}/v1/gan/${encodeURIComponent(orderId)}`);
  }

  realtime(orderId: string): Observable<unknown> {
    return this.http.get<unknown>(`${this.baseUrl}/v1/realtime/${encodeURIComponent(orderId)}`);
  }

  statistics(channelName?: string, sellerType?: string): Observable<StatsResponse> {
    let params = new HttpParams();
    if (channelName != null) {
      params = params.set('channelName', channelName);
    }
    if (sellerType != null) {
      params = params.set('sellerType', sellerType);
    }
    return this.http.get<StatsResponse>(`${this.baseUrl}/v1/statistics`, { params });
  }

  getDfdlOrder(orderId: string): Observable<any> {
    return this.http.post<any>(`https://custom.fastshop.krzlabs.io/api/gan/orders/${encodeURIComponent(orderId)}/create/simulate`,{
      "Domain": "Marketplace",
      "OrderId": orderId,
      "State": "order-created",
      "LastState": "not-started",
      "LastChange": "2025-06-19T16:15:56.842286Z",
      "CurrentChange": "2025-06-19T16:15:56.8708426Z",
      "Origin": {
        "Account": "fastshopbr",
        "Key": "vtexappkey-fastshopbr-NAGUNE"
      },
      "organization": "65201a17e8a8398d907c24a0"
    },
      {
    headers: {
      "x-krz-appkey":"fastshop_internal",
      "x-krz-appsecret":"27Xt080rcKqB608bxr4092gt8cvVwsRdW"
    },
        // @ts-ignore
        responseType: 'text'
      }
      );
  }

  getDfdlBilling(orderId: string): Observable<any> {
    return this.http.post<any>(`https://custom.fastshop.krzlabs.io/api/gan/orders/${encodeURIComponent(orderId)}/billing/simulate`,{
        "Domain": "Marketplace",
        "OrderId": orderId,
        "State": "ready-for-handling",
        "LastState": "not-started",
        "LastChange": "2025-06-19T16:15:56.842286Z",
        "CurrentChange": "2025-06-19T16:15:56.8708426Z",
        "Origin": {
          "Account": "fastshopbr",
          "Key": "vtexappkey-fastshopbr-NAGUNE"
        },
        "organization": "65201a17e8a8398d907c24a0"
      },
      {
        headers: {
          "x-krz-appkey":"fastshop_internal",
          "x-krz-appsecret":"27Xt080rcKqB608bxr4092gt8cvVwsRdW"
        },
        // @ts-ignore
        responseType: 'text'
      }


    );
  }
}
